import { ImCourseDiff } from 'Src/ng2/shared/services/im-models/im-course-diff';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { UtilitiesService } from 'Src/ng2/shared/services/utilities/utilities.service';
import { CreditRequirements } from '../../../../../ng2/shared/constants/credit-requirements.constant';
import { ImGapPlan } from '../../../../../ng2/shared/services/im-models/im-gap-plan';
import { ImStudentCreditGaps } from '../../../../shared/static-models/im-models/im-student-credit-gaps';

export class StudentCreditGapsPanelCtrl {
  static $inject = [
    '$scope',
    'ImStudentCreditGaps',
    'CourseDiff',
    'GapPlan',
    'ImSchool',
    'UtilitiesService',
    'ImGapPlan',
    'ImCourseDiff',
  ];

  public panelTitle = 'Credit Gaps';

  // Bindings
  public school;
  public student;
  public studentDiffs;
  public studentGapPlans;
  public isRestricted;

  // passed to child components
  public sharedState = {
    selectedCreditReq: CreditRequirements.TOTAL,
  };

  // for panel flags
  public summaryItems;

  private currentTermYear;
  private pendingCurrentTermCourseDiffs;
  private pendingCurrentTermGapPlans;
  private pendingAndFutureGapPlans;

  constructor(
    private $scope,
    private ImStudentCreditGaps: ImStudentCreditGaps,
    private CourseDiff,
    private GapPlan,
    private ImSchool: ImSchool,
    private UtilitiesService: UtilitiesService,
    private imGapPlan: ImGapPlan,
    private imCourseDiff: ImCourseDiff,
  ) {}

  $onInit() {
    this.setUi();
  }

  setUi(): void {
    this.currentTermYear = this.ImSchool.getCurrentTermYear(this.school);
    this.updatePanelFlags();
    this.$scope.$watch(
      () => {
        return this.studentDiffs;
      },
      () => {
        this.updatePanelFlags();
      },
      true,
    );
    this.$scope.$watch(
      () => {
        return this.studentGapPlans;
      },
      () => {
        this.updatePanelFlags();
      },
      true,
    );
  }

  updatePanelFlags = () => {
    this.summaryItems = [];
    this.pendingCurrentTermCourseDiffs = this.imCourseDiff.filterForPendingCurrentTerm(
      this.studentDiffs,
      this.currentTermYear,
    );
    this.pendingCurrentTermGapPlans = this.imGapPlan.filterForPending(this.studentGapPlans, this.currentTermYear);
    this.pendingAndFutureGapPlans = this.imGapPlan.filterForPendingAndFuture(
      this.studentGapPlans,
      this.currentTermYear,
    );
    const unaddressedCreditGapsFlag = this.getUnaddressedCreditGapsFlag();
    const pendingCourseChangesFlag = this.getPendingCourseChangesFlag();
    if (unaddressedCreditGapsFlag) this.summaryItems.push(unaddressedCreditGapsFlag);
    if (pendingCourseChangesFlag) this.summaryItems.push(pendingCourseChangesFlag);
  };

  getUnaddressedCreditGapsFlag = () => {
    let maxGaps: any = this.ImStudentCreditGaps.getMaxGapsWithNoPlan(
      this.student,
      this.pendingCurrentTermCourseDiffs,
      this.pendingAndFutureGapPlans,
      this.school,
    );
    let flag = null;
    const unaddressedGapsText = maxGaps === -1 ? 'UNADDRESSED CREDIT GAP' : 'UNADDRESSED CREDIT GAPS';
    if (maxGaps < 0) {
      maxGaps = this._formatMaxGaps(maxGaps);
      flag = {
        icon: 'flag',
        text: `${maxGaps} ${unaddressedGapsText}`,
      };
    }
    return flag;
  };

  _formatMaxGaps = maxGaps => {
    if (maxGaps % 1 === 0) {
      maxGaps = maxGaps.toFixed(0);
    } else {
      maxGaps = maxGaps.toFixed(2);
    }
    return maxGaps;
  };

  getPendingCourseChangesFlag() {
    const allPendingCourseChanges = this.pendingCurrentTermCourseDiffs.length + this.pendingCurrentTermGapPlans.length;
    const pendingCourseChangesText = allPendingCourseChanges === 1 ? 'PENDING COURSE CHANGE' : 'PENDING COURSE CHANGES';
    let flag = null;
    if (allPendingCourseChanges >= 1) {
      flag = {
        icon: 'flag',
        text: `${allPendingCourseChanges} ${pendingCourseChangesText}`,
      };
    }
    return flag;
  }

  setSharedState = (propName, value) => {
    // CreditRequirements has circular dependencies, so this is to avoid error when stringifying
    this.sharedState[propName] = null;
    const sharedStateCopy = this.UtilitiesService.copyPOJO(this.sharedState);
    sharedStateCopy[propName] = value;
    this.sharedState = sharedStateCopy; // triggers onChanges in child components
  };
}
